function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.99564 4.99585H17.5008C18.1915 4.99585 18.7514 5.55573 18.7514 6.24637V25.0042H4.99564C4.30499 25.0042 3.74512 24.4443 3.74512 23.7537V6.24637C3.74512 5.55573 4.30499 4.99585 4.99564 4.99585Z",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7515 9.99792H25.0041C25.6947 9.99792 26.2546 10.5578 26.2546 11.2484V23.7537C26.2546 24.4443 25.6947 25.0042 25.0041 25.0042H18.7515V9.99792Z",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.74733 9.84163C8.661 9.84163 8.59102 9.91161 8.59102 9.99794C8.59102 10.0843 8.661 10.1543 8.74733 10.1543C8.83366 10.1543 8.90365 10.0843 8.90365 9.99794C8.90365 9.91161 8.83366 9.84163 8.74733 9.84163",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7493 9.84163C13.663 9.84163 13.593 9.91161 13.593 9.99794C13.593 10.0843 13.663 10.1543 13.7493 10.1543C13.8356 10.1543 13.9056 10.0843 13.9056 9.99794C13.9056 9.91161 13.8356 9.84163 13.7493 9.84163",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.74733 14.8437C8.661 14.8437 8.59102 14.9137 8.59102 15C8.59102 15.0863 8.661 15.1563 8.74733 15.1563C8.83366 15.1563 8.90365 15.0863 8.90365 15C8.90365 14.9137 8.83366 14.8437 8.74733 14.8437",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7493 14.8437C13.663 14.8437 13.593 14.9137 13.593 15C13.593 15.0863 13.663 15.1563 13.7493 15.1563C13.8356 15.1563 13.9056 15.0863 13.9056 15C13.9056 14.9137 13.8356 14.8437 13.7493 14.8437",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.74733 19.8458C8.661 19.8458 8.59102 19.9158 8.59102 20.0021C8.59102 20.0884 8.661 20.1584 8.74733 20.1584C8.83366 20.1584 8.90365 20.0884 8.90365 20.0021C8.90365 19.9158 8.83366 19.8458 8.74733 19.8458",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7493 19.8458C13.663 19.8458 13.593 19.9158 13.593 20.0021C13.593 20.0884 13.663 20.1584 13.7493 20.1584C13.8356 20.1584 13.9056 20.0884 13.9056 20.0021C13.9056 19.9158 13.8356 19.8458 13.7493 19.8458",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5032 14.8437C22.4169 14.8437 22.3469 14.9137 22.3469 15C22.3469 15.0863 22.4169 15.1563 22.5032 15.1563C22.5895 15.1563 22.6595 15.0863 22.6595 15C22.6595 14.9137 22.5895 14.8437 22.5032 14.8437",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5032 19.8458C22.4169 19.8458 22.3469 19.9158 22.3469 20.0021C22.3469 20.0884 22.4169 20.1584 22.5032 20.1584C22.5895 20.1584 22.6595 20.0884 22.6595 20.0021C22.6595 19.9158 22.5895 19.8458 22.5032 19.8458",
  stroke: "#2C3589",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgJoratoUnits = function SvgJoratoUnits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoUnits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-units.df092a3c.svg";
export { ForwardRef as ReactComponent };